import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import {
  CreateNpsEvaluator,
  UpdateNpsEvaluator,
  FiltersNpsEvaluators
} from '@/Network/Types/Requests/NpsRequests'
import {
  NpsEvaluatorResponse,
  ListNpsEvaluatorsResponse
} from '@/Network/Types/Responses/NpsResponses'

export default class NpsEvaluatorService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/nps/evaluators'
  }

  async create(payload: CreateNpsEvaluator): Promise<NpsEvaluatorResponse> {
    const response = await request.post<NpsEvaluatorResponse>(this.getCompletePath(), payload)
    return response.data
  }

  async update(evaluatorId: number, payload: UpdateNpsEvaluator): Promise<NpsEvaluatorResponse> {
    const response = await request.put<NpsEvaluatorResponse>(
      `${this.getCompletePath()}/${evaluatorId}`,
      payload
    )
    return response.data
  }

  async toggleActive(evaluatorId: number, companyId: number): Promise<NpsEvaluatorResponse> {
    const response = await request.patch(
      `${this.getCompletePath()}/${evaluatorId}/toggle-active?companyId=${companyId}`,
      {}
    )

    return response.data as NpsEvaluatorResponse
  }

  async getById(evaluatorId: number): Promise<NpsEvaluatorResponse> {
    const response = await request.get<NpsEvaluatorResponse>(
      `${this.getCompletePath()}/${evaluatorId}`
    )
    return response.data
  }

  async delete(evaluatorId: number): Promise<void> {
    await request.delete(`${this.getCompletePath()}/${evaluatorId}`)
  }

  async list(filters?: FiltersNpsEvaluators): Promise<ListNpsEvaluatorsResponse> {
    try {
      const { data } = await request.get<ListNpsEvaluatorsResponse>(this.getCompletePath(), filters)
      return data
    } catch (e) {
      return {
        count: 0,
        data: []
      }
    }
  }
}
